/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class ExpectSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-3-et --white z-19 pb-40">
                    <div className="container relative-text p-40">
                        <div className="row m0">
                            <div className="col s12 center-align">
                                <h1 className="f-38 ls-1 red-text bold-text text-uppercase">What To <br/> <span className="f-100 ls-3">Expect</span></h1>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Learn how to become a phenomenon. Get clear on your vision, mission, values, beliefs, and perspective.</p>
                                </div>
                            </div>
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Learn exactly how to actually turn a profit and scale in 2018.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Break free of the generation of “trying” and become obsessed with execution.</p>

                                </div>
                            </div>
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-8">Overcome your self-doubt, fears, and rewire your brain for successful performance.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mb0">
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Learn proven, guaranteed marketing systems to make more sales for your business and convert more customers for less.</p>
                                </div>
                            </div>
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Rapid fire specific questions and receive tactical answers you can implement to overcome obstacles holding your business initiatives back.</p>
                                </div>
                            </div>
                        </div>
                        <div className="row mb0 pb-40">
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-20">Learn how to motivate your people and build great culture for your team.</p>
                                </div>
                            </div>
                            <div className="col s12 m6 left-align">
                                <div className="col s1 m1 left-align p0"><i className="fa fa-check f-18 brand-text brand-border-all" aria-hidden="true" /></div>
                                <div className="col s11 m11 left-align">
                                    <p className="red-text f-18 m0 pb-8">Build partnerships, network, and make new game changing relationships with people from around the world that can help take you to the next level (seriously underrated). <br className="hide-on-small-only" /><br className="hide-on-small-only" /></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default ExpectSection;


// WEBPACK FOOTER //
// ./src/components/expect-section.js